// Returns the API base URL for calling the PHP backend.
//
// During SSR we call the backend directly through the internal cluster Service
// (apiUrlInsideDocker), so the request stays east-west inside the cluster
// instead of looping back out through Cloudflare and the public load balancer.
// On the client we use the public apiUrl, because the browser cannot resolve
// the internal cluster DNS name.
export function useApiBaseUrl(): string {
    const config = useRuntimeConfig()

    return (process.client ? config.public.apiUrl : config.public.apiUrlInsideDocker) as string
}
